const globalFunctionsMixin = {
  methods: {
    mthGlobalConvertUnicodeCharsToUtf8Text(str) {
      let entities = [
        /*PL*/"u0105", "u0107", "u0119", "u0142", "u0144", "u00F3", "u015B", "u017A", "u017C", "u0104", "u0106", "u0118", "u0141", "u0143", "u00D3", "u015A", "u0179", "u017B",
        /*CZ*/"u00e1", "u010d", "u010f", "u00e9", "u011b", "u00ed", "u0148", "u00f3", "u0159", "u0161", "u0165", "u00fa", "u016f", "u00fd", "u017e", "u00c1", "u010c", "u010e", "u00c9", "u011a", "u00cd", "u0147", "u00d3", "u0158", "u0160", "u0164", "u00da", "u016e", "u00dd", "u017d",
        /*SK*/"u010c", "u010d", "u0160", "u0161", "u017d", "u017e",
        /*HU*/"u00e1", "u00c1", "u00e9", "u00c9", "u00ed", "u00cd", "u00f6", "u00d6", "u00f3", "u00d3", "u0151", "u0150", "u00fc", "u00dc", "u00fa", "u00da", "u0171", "u0170",
        /*RO*/"u0103", "u0102", "u00e2", "u00c2", "u00ee", "u00ce", "u0219", "u0218", "u015f", "u015e", "u021b", "u021a", "u0163", "u0162", "u013d" ,"u013e" ,
        /*LT*/"u0104", "u0105" ,"u010c", "u010d" ,"u0118", "u0119" ,"u0116" ,"u0117","u012e" ,"u012f" ,"u0160" ,"u0161", "u0172", "u0173" ,"u016a" ,"u016b", "u017d" ,"u017e", 
        /*INNE*/"u2013",
      ]
      let properchars = [
        /*PL*/"ą", "ć", "ę", "ł", "ń", "ó", "ś", "ź", "ż", "Ą", "Ć", "Ę", "Ł", "Ń", "Ó", "Ś", "Ź", "Ż",
        /*CZ*/"á", "č", "ď", "é", "ě", "í", "ň", "ó", "ř", "š", "ť", "ú", "ů", "ý", "ž", "Á", "Č", "Ď", "É", "Ě", "Í", "Ň", "Ó", "Ř", "Š", "Ť", "Ú", "Ů", "Ý", "Ž",
        /*SK*/"Č", "č", "Š", "š", "Ž", "ž",
        /*HU*/"á", "Á", "é", "É", "í", "Í", "ö", "Ö", "ó", "Ó", "ő", "Ő", "ü", "Ü", "ú", "Ú", "ű", "Ű",
        /*RO*/"ă", "Ă", "â", "Â", "î", "Î", "ș", "Ș", "ş", "Ş", "ț", "Ț", "ţ", "Ţ", "Ľ", "ľ" ,
        /*LT*/"Ą" ,"ą" ,"Č" ,"č", "Ę" ,"ę" ,"Ė" ,"ė" ,"Į", "į" ,"Š" ,"š" ,"Ų", "ų", "Ū", "ū" ,"Ž" ,"ž", 
        /*INNE*/"-",
      ]
      var ret = str;

      entities.forEach(
        function (item, index) {
          //ret = ret.replace(new RegExp(item, 'g'), properchars[index]);
          ret = ret.replace("\\" + item.toLowerCase(), properchars[index]);
          ret = ret.replace("\\" + item.toLowerCase(), properchars[index]);
          ret = ret.replace("\\" + item.toLowerCase(), properchars[index]);
          ret = ret.replace("\\" + item.toLowerCase(), properchars[index]);
          ret = ret.replace("\\" + item.toLowerCase(), properchars[index]);
          ret = ret.replace("\\" + item.toLowerCase(), properchars[index]);
          ret = ret.replace("\\" + item.toLowerCase(), properchars[index]);
          ret = ret.replace("\\" + item.toLowerCase(), properchars[index]);
          ret = ret.replace("\\" + item.toLowerCase(), properchars[index]);
          ret = ret.replace("\\" + item.toLowerCase(), properchars[index]);
          ret = ret.replace("\\" + item.toLowerCase(), properchars[index]);
          ret = ret.replace("\\" + item.toLowerCase(), properchars[index]);
        }
      );

      //     public static $arrBroken = array(
      //       "u0105", "u0107", "u0119", "u0142", "u0144", "u00F3", "u015B", "u017A", "u017C", "u0104", "u0106", "u0118", "u0141", "u0143", "u00D3", "u015A", "u0179", "u017B"
      //     );

      // public static $arrTarget = array(
      //       "ą", "ć", "ę", "ł", "ń", "ó", "ś", "ź", "ż", "Ą", "Ć", "Ę", "Ł", "Ń", "Ó", "Ś", "Ź", "Ż"
      //     );


      //console.log("e\\u0141");

      return ret;
    }
  }
}


export default globalFunctionsMixin